module.exports = __webpack_public_path__ + "static/media/TotalOutstandingAmountApplicanPortal.dc817732.svg";